// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__2DMi4","closeBtn":"Navbar_closeBtn__5ripW","linkDiv":"Navbar_linkDiv__31Sgt","links":"Navbar_links__2KAu-","bossboon":"Navbar_bossboon__1kwUk"};